/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S8_Li1_DescInputs */

const tr_iade_iptal_s8_li1_desc = /** @type {(inputs: Iade_Iptal_S8_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik bedelinin 30 günü aşan gecikmesi (en az 7 günlük ek süre verilerek ihtarname sonrası).`)
};

const en_iade_iptal_s8_li1_desc = /** @type {(inputs: Iade_Iptal_S8_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delay of the subscription fee exceeding 30 days (following a formal notice granting an additional period of at least 7 days).`)
};

const de_iade_iptal_s8_li1_desc = /** @type {(inputs: Iade_Iptal_S8_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzug mit dem Abonnemententgelt von mehr als 30 Tagen (nach Mahnung mit einer Nachfrist von mindestens 7 Tagen).`)
};

const ru_iade_iptal_s8_li1_desc = /** @type {(inputs: Iade_Iptal_S8_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просрочка оплаты подписки более 30 дней (после письменного предупреждения с предоставлением дополнительного срока не менее 7 дней).`)
};

/**
* | output |
* | --- |
* | "Delay of the subscription fee exceeding 30 days (following a formal notice granting an additional period of at least 7 days)." |
*
* @param {Iade_Iptal_S8_Li1_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s8_li1_desc = /** @type {((inputs?: Iade_Iptal_S8_Li1_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S8_Li1_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s8_li1_desc(inputs)
	if (locale === "de") return de_iade_iptal_s8_li1_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s8_li1_desc(inputs)
	return tr_iade_iptal_s8_li1_desc(inputs)
});